import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import CasePersonRoleServices from 'services/CasePersonRoleServices'; 

/**
 * VictimRoleDropDown - Autocomplete for victim roles, modeled after DepartmentDropDown
 *
 * Props:
 * - name, label, value, onChange, filter, required, validators, errorMessages
 */
const VictimRole = ({
    name,
    label,
    value,
    onChange,
    filter,
    required = false,
    validators = [],
    errorMessages = [],
}) => {
    const [data, setData] = useState([]);
    // Ensure filter is an object (guard if prop is undefined) and always enforce role_type = 'Victim'
    const [filters, setFilters] = useState({ ...(filter || {}), limit: 100, search: null, status: 'Active', role_type: 'Victim' });

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Assumption: CaseCommunicationsServices exposes a getAll method similar to DepartmentServices
                const [resp] = await Promise.all([
                    CasePersonRoleServices.getAll({ ...filters }),
                ]);

                // try to match the same response shape used in DepartmentDropDown
                setData(resp?.data?.view?.data || resp?.data || []);
            } catch (error) {
                console.error('Error fetching victim roles:', error);
            }
        };

        fetchData();
    }, [filters]);

    // Keep filters in sync if parent passes a new `filter` prop, but always enforce role_type:'Victim'
    useEffect(() => {
        if (!filter) return;
        // setFilters((prev) => ({ ...prev, ...(filter || {}), role_type: 'Victim' }));
    }, [filter]);

    useEffect(() => {
        // debug log for filters
        // console.log('VictimRole filters:', filters);
    }, [filters]);

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={data.find((item) => item.id === value) || null}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={data}
                getOptionLabel={(option) => option?.person?.name || option?.name || option?.label || ''}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value });
                }}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default VictimRole;
